<template>
  <div>
    <b-row style="margin-top: 2em">
      <b-col>
        <b-card bg-variant="light">
          <b-row>
            <b-col>
              <h5 class="text-info">
                {{ $t("globals.mollie_orders") }}
                {{ $t("globals.status") }}:
              </h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols='12' md='6'>
              <b-input-group>
                <b-form-input
                  size="sm"
                  v-model="mollie_payment_order_status"
                  disabled
                />
                <b-input-group-append>
                  <b-btn
                    size="sm"
                    v-if="mollie_payment_order_status == 'not_set_up'"
                    variant="info"
                    @click="setupOrderMollie"
                  >
                    {{ $t("globals.orders") }} {{ $t("globals.set_up") }}
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col>
              <b-btn
                v-if="mollie_payment_order_status !== 'not_set_up'"
                size="sm"
                variant="danger"
                class="float-right m-1"
                @click='resetMollie'
              >
                {{ $t("globals.reset") }}
              </b-btn>
            </b-col>
          </b-row>
          <!-- Mollie payments table -->
          <b-row>
            <b-col class="my-3">
              <b-input-group>
                <b-form-input
                  v-model="filter"
                  :placeholder="$t('globals.type_to_search')"
                />
                <b-input-group-append>
                  <b-btn
                    variant="warning"
                    :disabled="!filter"
                    @click="filter = ''"
                  >
                    {{ $t("globals.clear") }}
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col cols="2" class="my-3" >
              <b-form-select v-model="perPage" :options="perPageOptions" />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-table
                :items="mollie_payments"
                :fields="fields"
                :filter="filter"
                :current-page="currentPage"
                @filtered="onFiltered"
                :sortable = false
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                @row-clicked="rowClicked"
                hover
                small
                sort-icon-left
                
              >
                <template v-slot:cell(created_at)="item">
                  <div v-b-tooltip.hover :title="item.item.created_at">
                    {{ item.item.created_at.substring(0, 10) }}
                  </div>
                </template>
                <template v-slot:row-details="row">
                  <b-card border-variant="info">
                    <b-row>
                      <b-col>
                        <b-table small :items="row.item.audits">
                          <template v-slot:cell(action)="audit">
                            <div v-b-tooltip.hover :title="descriptionForAction(audit.item.action)">
                              {{ "*" + audit.item.action }}
                            </div>
                          </template>
                        </b-table>
                      </b-col>
                      <b-col cols="3" v-if="getUserBrandPermissions.super_admin && row.item.mollie_payment_id != null">
                        <b-btn size="sm" @click="openMolliePayment(row.item.mollie_payment_id)">
                          MolliePayment
                        </b-btn>
                      </b-col>
                    </b-row>
                  </b-card>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6" class="my-1">
              <b-pagination
                :total-rows="total"
                :per-page="perPage"
                v-model="currentPage"
                class="my-0"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { currencyFormat } from "@/helpers/price";
import { mapMutations,mapGetters, mapActions } from "vuex";

export default {
  props: {
    
    /*
    mollie_payment_parking_status: {
      type: String,
      default: ""
    },
    */
    customer:{
      type: Number,
      require: true
    },
    
    mollie_payment_order_status: {
      type: String,
      default: ""
    },
    refresh: Function
  },
  data() {
    return {
      total:0,
      mollie_payments:[],
      filter: null,
      sortBy: "created_at",
      currentPage: 1,
      sortDesc: true,
      perPage: 10,
      perPageOptions: [
        { text: "10 " + this.$t("globals.per_page"), value: 10 },
        { text: "20 " + this.$t("globals.per_page"), value: 20 },
        { text: "30 " + this.$t("globals.per_page"), value: 30 }
      ],
      fields: [
        "id",
        {
          key: "status",
          label: this.$t("globals.status"),
          sortable: true
        },
        {
          key: "payment_method",
          label: this.$t("globals.payment_method"),
          sortable: true
        },
        {
          key: "invoice_type",
          label: this.$t("globals.invoice_type"),
          sortable: true
        },
        {
          key: "invoice_no",
          label: this.$t("globals.invoice_no"),
          sortable: true
        },
        {
          key: "created_at",
          label: this.$t("globals.created_at"),
          sortable: true
        }
      ]
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation","simpleFetch"]),
    ...mapMutations(["setShowLoadingModal"]),
    setupOrderMollie() {
      let data = {
        query: `
          mutation MollieSetUpOrder ($customer_id: ID!) {
            res: MollieSetUpOrder (customer_id: $customer_id)
          }
        `,
        variables: {
          customer_id: parseInt(this.$route.params.id)
        }
      };
      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.refresh();
      });
    },
    resetMollie() {
      const confirmText = "Are you sure? Did you check the customer for any pending mollie payments? *If any orders are already set to mollie and customer won't setup new mollie in time for the next invoice it will result in an error";

      let data = {
        query: `
          mutation MollieSetUpOrder ($customer_id: ID!) {
            res: MollieSetUpOrder (customer_id: $customer_id)
          }
        `,
        variables: {
          customer_id: parseInt(this.$route.params.id)
        }
      };
      this.simpleMutation({ data, confirm_text: confirmText, this_ref: this }).then(() => {
        this.refresh();
      });
    },
    rowClicked(item) {
      item._showDetails = !item._showDetails;
      this.mollie_payments.forEach(payment => {
        if (item.id != payment.id) {
          payment._showDetails = false;
        }
      });
    },
    openMolliePayment(mollie_payment_id) {
      window.open(
        `https://www.mollie.com/dashboard/org_7462221/payments/${mollie_payment_id}`,
        "_blank"
      );
    },
    onFiltered() {
      this.currentPage = 1;
    },
    descriptionForAction(action) {
      let desc = "";
      switch (action) {
        case "created":
          desc = "The payment was created locally"
          break;
        case "open":
          desc = "The payment was created on Mollie and is awaiting actions"
          break;
        case "paid":
          desc = "The payment was paid"
          break;
        case "canceled":
          desc = "The payment was canceled by the customer"
          break;
        case "expired":
          desc = "The customer didnt set up mollie in time"
          break;
      }
      return desc
    },
    fetchTotalMollie(){
      const data = {
        query: `query { Customer(id:${parseInt(this.customer)}){ mollie_payments_total }}`
      };
      this.setShowLoadingModal(true);
      this.simpleFetch({ data, this_ref: this })
        .then(res => {
          if (res) {
            this.total = res.Customer.mollie_payments_total;
          }
        })
        .finally(() => {
          this.setShowLoadingModal(false);
      });
    },
    fetchMollie() {
      const offset = (this.currentPage-1) * this.perPage;
      const sort = this.sortDesc ? 'desc' : 'asc'
      const data = {
        query: `
        query { 
          Customer(id:${parseInt(this.customer)}){  
            molliePaymentPagination (
              sortBy:"${this.sortBy}", 
              sort:"${sort}"
              limit: ${parseInt(this.perPage)},
              offset: ${parseInt(offset)}
            )
            {
              id
              mollie_payment_id
              status
              payment_method
              invoice_type
              invoice_no
              invoice_id
              created_at
              _showDetails
              _rowVariant
              audits {
                action
                created_at
              }
            }
          }
        }
        `
      };

      this.setShowLoadingModal(true);
      this.simpleFetch({ data, this_ref: this })
        .then(res => {
          if (res) {
            this.mollie_payments = res.Customer.molliePaymentPagination;
          }
        })
        .finally(() => {
          this.setShowLoadingModal(false);
        });
    },
  },
  mounted() {
    this.fetchTotalMollie();
  },
  watch:{
    total(n,o){
      if(this.total>0){
        this.fetchMollie();
      }
    },
    currentPage(n,o){
      this.fetchMollie();
    },
    perPage(n,o){
      this.fetchMollie();
    },
    sortBy(n,o){
      this.fetchMollie();
      // this.currentPage = 1; // To stay in the current page keep this commented, if after a sort it needs to go to the first page, uncomment
    },
    sortDesc(n,o){
      this.fetchMollie();
      // this.currentPage = 1; // To stay in the current page keep this commented, if after a sort it needs to go to the first page, uncomment
    }
  },
  computed: {
    ...mapGetters(["getUserBrandPermissions"])
  }
};
</script>
